import { render, staticRenderFns } from "./DownloadExcelButton.vue?vue&type=template&id=220e4630"
import script from "./DownloadExcelButton.vue?vue&type=script&lang=js"
export * from "./DownloadExcelButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports